import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { UploadedFile } from '../models/uploaded-file.model';
import { LiabilityService } from './liability.service';

@Injectable({
  providedIn: 'root',
})
export class LiabilityScanService {
  constructor(private sanitizer: DomSanitizer, private liabilityService: LiabilityService) {}

  public getFileUrl(file: UploadedFile): string {
    return URL.createObjectURL(file.fileData);
  }

  public getFileUrlSafe(file: UploadedFile): SafeResourceUrl {
    const objectURL = URL.createObjectURL(file.fileData);
    return this.sanitizer.bypassSecurityTrustResourceUrl(objectURL);
  }

  public revokeFileUrl(file: UploadedFile): void {
    URL.revokeObjectURL(file.url.toString());
  }

  public uploadDocumentsForAutomaticReading(files: File[]): Observable<string> {
    return this.liabilityService.uploadDocumentsForAutomaticReading(files);
  }
}
